<!-- =========================================================================================
  File Name: SimulationSelector.vue
  Description: eCommerce Shop Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
    Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div>

    <div class="rounded-lg justify-between items-center rounded-lg mb-4"
         style="background-image: url(https://cdn.discordapp.com/attachments/733851758211629347/954057924391600218/BG.png);
           box-shadow: rgb(0 0 0 / 10%) 0px 4px 25px 0px;">
      <div class=" flex justify-between items-center rounded-lg p-4" style="backdrop-filter: blur(10px)">

        <div class="flex items-center">
          <img alt="simulations" draggable="false"
               src="https://connect-cdn.intellectualpoint.com/assets/images/apps/SimulationsIcon.png"
               class="rounded hidden sm:block mr-5" style="width: 75px">
          <div>
            <h1 class="font-bold">Simulation Selector</h1>
            <h5 class="font-light">{{ simulations.length }} Total Simulations</h5>
          </div>
        </div>


        <div class="flex flex-col items-end justify-center" style="min-width: 30rem">
          <vs-input v-model="simulationSearch" placeholder="Search For Simulation" @input="filterSimulations"
                    class="w-full" color="primary" icon-pack="feather" icon="icon-search" icon-no-border></vs-input>
        </div>


      </div>
    </div>

    <div v-if="simulationsLoaded">
      <div class="simulations-grid-view vx-row match-height">
        <div v-for="item in simulations" :key="item.id"
             class="vx-col card-width-sims">
          <simulation-card :item="item"/>
        </div>
      </div>
      <h1 v-if="!simulations.length">No Simulations Found</h1>
    </div>
    <div class="simple-spinner" v-else>
      <span></span>
    </div>
  </div>

</template>

<script>
import SimulationCard from './components/SimulationCard'
import LottieAnimation from '../../../../components/lottie/LottieAnimation'

export default {
  components: {
    SimulationCard,
    LottieAnimation
  },
  data () {
    return {
      simulations: [],
      simulationsTotal: [],
      simulationsLoaded: false,

      simulationSearch: '',

      productsTotal: 0,
      paginationPageSize: 500,
      currentPage: 1,
      showHiddenSimulations: false

    }
  },
  computed: {
    activeCourseInfo () {
      return this.$store.state.AppActiveCourse
    }
  },
  methods: {
    filterSimulations () {
      this.simulations = this.simulationsTotal.filter((simulation) => {
        return simulation.name.toLowerCase().includes(this.simulationSearch.toLowerCase().trim())
      })
    },
    loadSimulationsData (page = 0) {
      this.simulationsLoaded = false

      if (this.activeCourseInfo.selected === false) {
        this.$vs.notify({
          title: 'No Course Selected',
          text: 'Please select a courses before practicing',
          color: 'danger',
          position: 'top-right'
        })
        return this.$router.push('/courses')
      }

      if (page === 0) {
        page = this.currentPage
      }

      this.$http.get(`app/simulations/selector?amount=${this.paginationPageSize}&page=${page}&hidden=${this.showHiddenSimulations}`)
        .then(response => {

          if (response.data.data) {
            if (response.data.data.length === 0) {
              this.$vs.notify({
                title: 'No Simulations In Course',
                text: 'There are no simulations in the course you are trying to practice',
                color: 'danger',
                position: 'top-right'
              })
              return this.$router.push('/apps')
            }

            this.simulationsTotal = response.data.data
            this.simulations = this.simulationsTotal
            this.simulationsLoaded = true

          }
        }).catch(exception => {

          let error = 'An unknown error occurred while loading simulations'
          if (exception.response) {
            error = exception.response.data.error.description
          }

          return this.$vs.notify({
            title: 'Failed To Load Course Simulations',
            text: error,
            color: 'danger',
            position: 'top-right'
          })
        })

    }
  },
  beforeMount () {
    this.loadSimulationsData()
  }
}

</script>


<style lang="scss" scoped>

.html {
  overflow-y: scroll !important;
}

.card-width-sims {
  width: 20%;
}

@media (max-width: 2200px) {
  .card-width-sims {
    width: 25%;
  }
}

@media (max-width: 1800px) {
  .card-width-sims {
    width: 33.333333%;
  }
}

@media (max-width: 1300px) {
  .card-width-sims {
    width: 50%;
  }
}

@media (max-width: 750px) {
  .card-width-sims {
    width: 100%;
  }
}


</style>

